
export class FilterArquivoHeader {

  nroDocumento?: string;
  dtaInicio?: Date;
  dtaFim?: Date;
  tpoSentido?: string;
  dscStatus?: string;
  fileName?: string;
  codBanco?: number;
  nsa?: number;

}
